import React from "react";
import { Box } from '@mui/joy';

const ImprenditoreVero = () => {
    return <Box style={{marginTop:'100px', fontSize:'90px', color:'var(--neutral-200)' }}>DASHBOARD DA DEFINIRE</Box>
}

export default ImprenditoreVero;